import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Watch from '../views/Watch.vue'
import Login from '../views/Login.vue'
import { isLoggedIn } from '../utils/auth'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  routes: [
    { path: '/login', name: 'Login', component: Login, meta: { public: true } },
    { path: '/', name: 'Home', component: Home, meta: { requireAuth: true } },
    { path: '/watch/:shareCode', name: 'Watch', component: Watch, meta: { public: true } }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.requireAuth && !isLoggedIn()) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
    return
  }
  if (to.name === 'Login' && isLoggedIn()) {
    next({ path: '/' })
    return
  }
  next()
})

export default router
